import { useState } from "react";
import Sidebar from "./Sidebar";
import Doctors from "./Doctors";
import Appointments from "./Appointments";
import Patients from "./Patients";
import FloatingParticles from "../components/FloatingParticles";
import AdminDashboard from "./AdminDashboard";

export default function AdminLayout() {
  const [active, setActive] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderPage = () => {
    switch (active) {
      case "dashboard":return <AdminDashboard/>;
      case "doctors": return <Doctors />;
      case "appointments": return <Appointments />;
      case "patients": return <Patients />;
      default: return <AdminDashboard />;
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "linear-gradient(135deg,#f0f9ff,#e0f2fe)", fontFamily: "'Outfit',sans-serif", color: "#1e293b", position: "relative" }}>
      <style>{`
        /* ── Admin Layout responsive ── */
        .admin-main {
          flex: 1;
          margin-left: 294px;
          padding: 32px 40px;
          overflow-y: auto;
          position: relative;
          z-index: 10;
          min-height: 100vh;
          transition: margin-left 0.4s ease;
        }
        .admin-topbar {
          display: none;
          align-items: center;
          gap: 12px;
          position: sticky;
          top: 0;
          z-index: 100;
          background: rgba(240,249,255,0.95);
          backdrop-filter: blur(14px);
          border-bottom: 1px solid #bae6fd;
          padding: 12px 16px;
          margin: -32px -32px 24px -32px;
        }
        .admin-hamburger {
          background: none;
          border: none;
          cursor: pointer;
          padding: 6px;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          gap: 5px;
          transition: background 0.2s;
        }
        .admin-hamburger:hover { background: #e0f2fe; }
        .admin-hamburger span {
          display: block;
          width: 22px;
          height: 2.5px;
          background: #0284c7;
          border-radius: 2px;
          transition: all 0.3s ease;
        }
        .admin-hamburger.open span:nth-child(1) { transform: translateY(7.5px) rotate(45deg); }
        .admin-hamburger.open span:nth-child(2) { opacity: 0; transform: scaleX(0); }
        .admin-hamburger.open span:nth-child(3) { transform: translateY(-7.5px) rotate(-45deg); }
        @media (max-width: 768px) {
          .admin-main { margin-left: 0; padding: 32px 16px 16px; }
          .admin-topbar { display: flex; }
        }
      `}</style>

      <FloatingParticles />

      {/* Sidebar */}
      <Sidebar
        active={active}
        setActive={setActive}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main Content Area */}
      <div className="admin-main">
        {/* Mobile top bar */}
        <div className="admin-topbar">
          <button
            id="admin-hamburger-btn"
            className={`admin-hamburger ${sidebarOpen ? "open" : ""}`}
            onClick={() => setSidebarOpen(prev => !prev)}
            aria-label="Toggle admin navigation"
          >
            <span /><span /><span />
          </button>
          <div style={{ fontWeight: 800, fontSize: "17px", color: "#0c4a6e", display: "flex", alignItems: "center", gap: "6px" }}>
            <span>⚡</span> Admin <span style={{ color: "#2563eb" }}>Portal</span>
          </div>
        </div>

        {renderPage()}
      </div>
    </div>
  );
}